// import {
//   FacebookIcon,
//   InstagramIcon,
//   LinkedinIcon,
//   TelegramIcon,
//   TwitterIcon,
//   YoutubeIcon,
// } from "../../assets";
import {
  ABOUT_LCX_LINK,
  AMAZON_STORE_LINK,
  AUTHOR_PROFILE_LINK,
} from "../../constants";

const Footer = () => {
  const LINKS = [
    { label: "About Author", path: AUTHOR_PROFILE_LINK },
    { label: "About LCX", path: ABOUT_LCX_LINK },
    { label: "Buy Book on Amazon", path: AMAZON_STORE_LINK },
  ];

  // const SOCIAL_LINKS = [
  //   {
  //     name: "facebook",
  //     icon: FacebookIcon,
  //     url: "https://www.facebook.com/LCX.exchange/",
  //   },

  //   {
  //     name: "twitter",
  //     icon: TwitterIcon,
  //     url: "https://twitter.com/lcx",
  //   },
  //   {
  //     name: "linkedin",
  //     icon: LinkedinIcon,
  //     url: "https://www.linkedin.com/company/lcx",
  //   },
  //   {
  //     name: "instagram",
  //     icon: InstagramIcon,
  //     url: "https://www.instagram.com/lcx.exchange/",
  //   },

  //   {
  //     name: "youtube",
  //     icon: YoutubeIcon,
  //     url: "https://www.youtube.com/channel/UCNj78acRE-ywQPim-wZ8RTQ",
  //   },
  //   {
  //     name: "telegram",
  //     icon: TelegramIcon,
  //     url: "https://t.me/JoinLCX",
  //   },
  // ];
  return (
    <div className="footer">
      <div className="footer__links">
        {LINKS.map((link, i) => (
          <a
            key={i}
            className="footer__link"
            href={link.path}
            target="_blank"
            rel="noopener noreferrer"
          >
            {link.label}
          </a>
        ))}
      </div>
      {/* <div className="footer__sociallinks">
        {SOCIAL_LINKS.map((platform) => (
          <a
            key={platform.name}
            href={platform.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={platform.icon} alt={platform.name} />
          </a>
        ))}
      </div> */}
    </div>
  );
};

export default Footer;
